import { render, staticRenderFns } from "./AppDrag.vue?vue&type=template&id=c81c9b86&scoped=true&"
import script from "./AppDrag.vue?vue&type=script&lang=js&"
export * from "./AppDrag.vue?vue&type=script&lang=js&"
import style0 from "./AppDrag.vue?vue&type=style&index=0&id=c81c9b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81c9b86",
  null
  
)

export default component.exports